
<div class="container-mobile">
  <router-outlet></router-outlet>
  <!--<ng-container *ngIf="authService.getUser">
    <app-skeleton-bottom-menu></app-skeleton-bottom-menu>
  </ng-container>-->
  <app-skeleton-left-menu *ngIf="showLeftMenu"></app-skeleton-left-menu>
  <app-loader *ngIf="loaderService.spinnerShow"></app-loader>
</div>
<div class="container-high-resolution">
  La plataforma PULPI - FINSUS solo esta disponible en celulares.
</div>
